import React, { useState } from "react";
import Navbar from "../components/Navbar";
import PersonalForm from "./components/PersonalForm";

export default function Personal(props) {
  const current_user = props.current_user

  return (
    <div className="min-h-full bg-gray-50">
      <div className="pb-20">
        <Navbar props={props} />

      </div>

      {/* Основной контент */}
      <main className="">
        <div className="mx-auto container max-w-screen-2xl px-4 pb-12">
            <PersonalForm current_user={current_user} />
        </div>
      </main>
    </div>
  );
}
